import React from 'react';
import { Button, Typography } from 'antd';
import PropTypes from 'prop-types';
import { CloseOutlined } from '@ant-design/icons';
import quickTpSvg from '../../assets/images/quick tip.svg';
import './joyrideTooltip.scss';

function joyrideCustomTooltip(props) {
  const { backProps, continuous, index, isLastStep, primaryProps, size, step, closeProps } = props;
  return (
    <>
      {/* Render buttons based on the step index */}
      {index > 0 && !isLastStep && (
        <div className="phase-wise">
          <Typography.Title level={5} style={{ marginTop: '-4px', fontSize: '18px' }}>
            {step.title}
          </Typography.Title>
          <Typography.Text className="content-wrapper">{step.content}</Typography.Text>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              gap: '16px'
            }}
          >
            <Typography.Text>
              {index} &nbsp;/&nbsp; {size - 2}
            </Typography.Text>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                gap: '16px'
              }}
            >
              {index > 1 ? (
                <Button {...backProps} size="small">
                  <Typography.Text>Previous</Typography.Text>
                </Button>
              ) : (
                ''
              )}
              <Button {...primaryProps} type="primary" size="small">
                <Typography.Text style={{ color: 'white' }}>{continuous && 'Next'}</Typography.Text>
              </Button>
            </div>
          </div>
        </div>
      )}
      {isLastStep && (
        <div className="container">
          <Button {...primaryProps} className="cross-btn">
            {continuous && <CloseOutlined />}
          </Button>
          <img src={quickTpSvg} alt="Quick Tip" style={{ marginRight: '8px' }} />
          <Button {...closeProps} size="small" className="btn">
            <Typography.Text>End Tour</Typography.Text>
          </Button>
        </div>
      )}
    </>
  );
}

joyrideCustomTooltip.propTypes = {
  props: PropTypes.instanceOf(Object)
};
export default joyrideCustomTooltip;
